import React from 'react';

import '../styles.scss';

interface IGuidanceTooltipPosition {
    top?: string;
    bottom?: string;
    left?: string;
    right?: string;
}

interface IGuidanceTooltipSingle {
    text?: string;
    num?: number | string;
    position?: IGuidanceTooltipPosition;
    maxHeight?: string | number;
}

interface IGuidanceTooltipProps extends IGuidanceTooltipSingle {
    list?: IGuidanceTooltipSingle[];
}

const Tooltip = (props: {
    num: number | string;
    text: string;
    index?: number;
    position?: IGuidanceTooltipPosition;
    maxHeight?: string | number;
}) => {
    const inlineStyle: React.CSSProperties = {
        ...(props.position && {
            ...(props.position.top && {top: props.position.top}),
            ...(props.position.bottom && {bottom: props.position.bottom}),
            ...(props.position.left && {left: props.position.left}),
            ...(props.position.right && {right: props.position.right})
        }),
        ...(props.maxHeight != null && {maxHeight: props.maxHeight})
    };

    return (
        <div
            className={`agent-guidance-tooltip step-${props.num}`}
            style={Object.keys(inlineStyle).length > 0 ? inlineStyle : undefined}>
            <span className={'step-num'}>{props.num}</span>
            <span dangerouslySetInnerHTML={{__html: props.text}} />
        </div>
    );
};

const GuidanceTooltip: React.FunctionComponent<IGuidanceTooltipProps> = ({
    num,
    text,
    list,
    position,
    maxHeight
}: IGuidanceTooltipProps) =>
    list ? (
        <React.Fragment>
            {list.map((tooltip: IGuidanceTooltipSingle, index: number) => (
                <Tooltip
                    key={`guidanceTooltip${index}`}
                    num={tooltip.num!}
                    text={tooltip.text!}
                    position={tooltip.position}
                    maxHeight={tooltip.maxHeight}
                />
            ))}
        </React.Fragment>
    ) : (
        <Tooltip num={num!} text={text!} position={position} maxHeight={maxHeight} />
    );

export default GuidanceTooltip;
